import { render, staticRenderFns } from "./DfCheckboxField.vue?vue&type=template&id=20e3aa21&scoped=true&"
import script from "./DfCheckboxField.vue?vue&type=script&lang=js&"
export * from "./DfCheckboxField.vue?vue&type=script&lang=js&"
import style0 from "./DfCheckboxField.vue?vue&type=style&index=0&id=20e3aa21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3aa21",
  null
  
)

export default component.exports